export const SEATS = [0, 1, 2, 3];
export const SUITS = ["clubs", "diamonds", "hearts", "spades"];
export const NATURAL_RANKS = [
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "J",
    "Q",
    "K",
    "A",
];
export const DEFAULT_RULE_PROFILE = Object.freeze({
    id: "default",
    wildcardInStraightFlush: true,
    antiTributeBigJokerCount: 2,
    allowA2345Straight: true,
    straightFlushBeatsBombSize: 5,
    finishMode: "through-ace",
    fixedRounds: 8,
    timeoutTakeoverAfter: 2,
});
export class InvalidGameActionError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = "InvalidGameActionError";
        this.code = code;
    }
}
//# sourceMappingURL=types.js.map